<!--打款记录-->
<template>
  <div class="com-table balance border">
    <div class="com-title pr">充值记录</div>
    <MsSearch :data="search.list" @click="updateConditions"></MsSearch>
    <el-table
      :data="table.list"
      style="width: 100%"><template slot="empty">
      <no-data></no-data>
    </template>
      <el-table-column
        prop="id"
        label="ID"
        >
      </el-table-column>
      <el-table-column
        prop="itemTitle"
        label="项目名称">
      </el-table-column>
      <el-table-column
        prop="money"
        label="充值金额">
      </el-table-column>
      <el-table-column
        prop="type"
        label="充值类型">
        <template slot-scope="scope">
          <span v-if="scope.row.type === 1">普通充值</span>
          <span v-else>招商智投（智投）</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="payTime"
        label="到账日期">
      </el-table-column>
      <el-table-column
        prop="remark"
        label="备注">
      </el-table-column>
      <el-table-column
        prop="publishTime"
        label="录入日期">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, sizes, prev, pager, next, jumper"
      :current-page.sync="table.pagination.page"
      :total="table.pagination.totalRow"
      :page-size="table.pagination.pageSize"
      :page-sizes="table.pagination.pageSizes"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>
<script>
  import MsSearch from '@/components/common/Search.vue'
  import StatisticsApi from '@/api/statistics'
  import Api from '@/api/payment'
  import { SEARCH_CONDITION } from '@/models/payment'
  import ResponseParse from '@/utils/response-parse'

  export default {
    components: {
      MsSearch
    },
    data () {
      return {
        search: {
          list: [],
          condition: {}
        },
        titleName: {},
        table: {
          list: [],
          pagination: {},
          loading: true
        }
      }
    },
    created () {
      this.search.list = SEARCH_CONDITION
      this.table.list = []
      this.requestList()
      this.customerItems()
    },
    methods: {
      customerItems () {
        const search = Object.assign({}, this.pagination, this.search.condition)
        StatisticsApi.customerItem({search: search}, response => {
          let status = response.data.code
          let data = response.data
          if (status === '200') {
            this.titleName = data.data
            this.search.list[0].config.list = []
            let project = []
            this.titleName.forEach(item => {
              if (item.status === 1) {
                project.unshift({value: item.title, label: item.title})
              } else {
                project.push({value: item.title, label: item.title, disabled: true})
              }
            })
            this.search.list[0].config.list = project
          }
          this.table.loading = false
        })
      },
      requestList () {
        this.table.loading = true
        const search = Object.assign({}, this.table.pagination, this.search.condition)
        Api.list({search: search}, response => {
          let status = response.data.code
          let body = response.data.data || []
          if (status === '200') {
            this.table.list = body
            this.table.pagination = ResponseParse.pagination(response.headers)
          } else {
            this.table.list = []
          }
          this.table.loading = false
        })
      },
      handleSizeChange (val) {
        this.table.pagination.pageSize = val
        this.requestList()
      },
      handleCurrentChange (val) {
        this.table.pagination.page = val
        this.requestList()
      },
      updateConditions (conditions) {
        this.table.pagination.page = 1
        this.search.condition = conditions
        this.requestList()
      },
      dataFormat (row, column) {
        const data = row[column.property] + ''
        if (data === '' || data === undefined) {
          return ''
        } else {
          const pattern = /(?=((?!\b)\d{3})+$)/g
          return (data.replace(pattern, ',')) + ' 元'
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '../../assets/styles/env';

</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/client/PaymentRecord.vue